var _defs, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportifyIconSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill-rule:evenodd;}.cls-1{fill:url(#GradientFill_1);}.cls-2{fill:url(#GradientFill_2);}.cls-3{fill:url(#GradientFill_3);}.cls-4{fill:url(#GradientFill_4);}.cls-5{fill:url(#GradientFill_5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 500,
    y1: 1000,
    x2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbae47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2",
    x1: 382.72,
    y1: 986.62,
    x2: 382.72,
    y2: 241.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef4629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#f1582f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e84125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    x1: 492.07,
    y1: 656.39,
    x2: 653.15,
    y2: 656.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e84125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_4",
    x1: 637.82,
    y1: 432.18,
    x2: 838.06,
    y2: 310.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f57f3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6883e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_5",
    x1: 123.16,
    y1: 332.84,
    x2: 418.36,
    y2: 332.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89840"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.9,870.23C116,534.51,544.93,467.54,538.71,227.05,662.59,395,667.54,452,537,585.64c-40,40.93-105.51,115.06-18,160.24C626.59,657.7,675.6,585.76,675.6,585.76c81.29,167.81-103,229.76-87.39,303.57C622.58,1052,847.31,1013.17,947,869c147.49-213.23-60.57-330.77-51.82-558.42-30.29,59.22-79,122-163.4,165.83C856.8,284.56,681.94,193.77,531.43,0,383.22,59.74,446,200,349.68,323.83,254,446.88,136.09,485.1,140.44,316.41,11.6,490.28-76.73,730.19,96.39,905.1c33.14,33.49,75.63,68.67,139.09,84.47C382.14,1026.07,440.65,962.11,370.9,870.23Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.9,870.23C140.51,566.76,468.84,482.88,529.45,291.94L489,241.5C450.26,428.72,174.62,559.09,248.5,756.34,275.71,829,351.87,912.55,372.72,986.62,408.75,965.79,410.61,922.53,370.9,870.23Z",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M634.93,566.89c-57.1,85.61-126.2,145.91-142.86,159.87,6.62,6.78,15.46,13.2,26.94,19.12,66.06-54.15,110-102.18,134.14-131.18C644.17,584.64,634.93,566.89,634.93,566.89Z",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.64,533.43q229.25-7,252.54-222.81c-30.29,59.22-79,122-163.4,165.83C799,373.31,779.54,299.39,723.83,223,784.11,329.9,728.85,447.14,642.64,533.43Z",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.44,316.41c-106.62,395.18,316.88,81,275-155.19-12.12,52-23.95,108.87-65.75,162.61C254,446.88,136.09,485.1,140.44,316.41Z",
    transform: "translate(0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportifyIconSquare);
export default __webpack_public_path__ + "static/media/sportify-icon-square.1b889a6a833507b1b76062c495caa5de.svg";
export { ForwardRef as ReactComponent };